import React, { useCallback } from 'react';
import { Round as ArrowIcon } from '@tamagoshi/icons/ArrowForwardIos';
import PropTypes from 'prop-types';
import { ProductFamilyPropType } from '@propTypes';
import { Icon } from '@components';
import { getProductId } from '@modules/utils';
import styles from './styles/index.module.scss';

const MenuItem = ({ item, onClick, className, icon }) => {
  const handleClick = useCallback(
    e => {
      onClick(e, item.id);
    },
    [item.id, onClick],
  );

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
  return (
    <li className={className} onClick={handleClick}>
      {icon ? <Icon size="30" id={icon} className={styles.icon} /> : null}
      {item.level === 0 && (
        <Icon
          id={getProductId(item.id)}
          size="18"
          className={styles.familyIcon}
        />
      )}
      {item.name}
      <ArrowIcon className={styles.arrow} />
    </li>
  );
};

MenuItem.propTypes = {
  item: ProductFamilyPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string,
};

MenuItem.defaultProps = {
  className: '',
  icon: '',
};

MenuItem.displayName = 'MenuItem';

export default MenuItem;
